(function () {
  var root = document.querySelector(".sta-lp");
  if (!root) return;

  root.classList.add("sta-js");

  Array.prototype.forEach.call(root.querySelectorAll(".sta-hero-video"), function (video) {
    video.addEventListener("loadedmetadata", function () {
      if (video.duration > 1.2 && video.currentTime < 0.3) {
        try {
          video.currentTime = 0.8;
        } catch (error) {
          return;
        }
      }
    }, { once: true });
  });

  Array.prototype.forEach.call(root.querySelectorAll('a[href^="#"]'), function (link) {
    link.addEventListener("click", function (event) {
      var targetId = link.getAttribute("href").slice(1);
      var target = document.getElementById(targetId);
      if (!target) return;

      event.preventDefault();
      target.scrollIntoView({ behavior: "smooth", block: "start" });
      window.history.pushState(null, "", "#" + targetId);
    });
  });

  var targets = Array.prototype.slice.call(root.querySelectorAll(".sta-reveal"));
  if (!("IntersectionObserver" in window)) {
    targets.forEach(function (target) {
      target.classList.add("sta-is-visible");
    });
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add("sta-is-visible");
      observer.unobserve(entry.target);
    });
  }, {
    root: null,
    rootMargin: "0px 0px -12% 0px",
    threshold: 0.12
  });

  targets.forEach(function (target) {
    observer.observe(target);
  });
})();
